// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gw-0";
export var actionModalContentContainer = "_gw-1";
export var createTagButton = "_gw-2";
export var footerContainer = "_gw-7";
export var fullWidthDivider = "_gw-3";
export var hasCreateTagButton = "_gw-4";
export var noCreateTagButton = "_gw-5";
export var tagsContainer = "_gw-6";
export var tagsModalContentContainer = "_gw-8";